/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.preLoad)();
	  (0, _module.anchorLink)();
	  (0, _module.navSticky)();
	  (0, _module.spMenu)();
	  (0, _module.placeNav)();
	  var artistList = Array.prototype.slice.call(document.querySelectorAll('.art-Contents_Artist_Flex'), 0); // 12個(indexArrayと同じ数)
	
	  var artistLink = Array.prototype.slice.call(document.querySelectorAll('.sw-Submenu_Item a'), 0); // console.log(artistList);
	
	  var targetResponsesource = []; // 取得したjsonを格納する配列
	
	  var targetResponse = []; // 取得したjsonを格納する配列
	
	  var targetUrl = '../assets/json/artist/data.json'; // 現在のURLから見たjsonの位置
	
	  var indexArray = ['あ', 'か', 'さ', 'た', 'な', 'は', 'ま', 'や', 'ら', 'わ', '英字', '記号'];
	  var addItemflag = "";
	  window.addEventListener('load', function () {
	    if (artistList[0]) {
	      readData();
	    }
	  }, false); // ---------------------------------------------------------------------------
	  // @function readData
	  // jsonのデータを非同期で取得する関数
	  // ---------------------------------------------------------------------------
	
	  var readData = function readData() {
	    var x = new XMLHttpRequest();
	
	    x.onreadystatechange = function () {
	      if (x.readyState === 4) {
	        if (x.status === 200) {
	          targetResponse = x.response; // 非同期でファイルを取得できたら格納用の配列に格納
	          // IE11の場合パース
	
	          if (JSON) {
	            if (navigator.userAgent.indexOf('Trident') !== -1) {
	              targetResponse = JSON.parse(targetResponse);
	            }
	          } // targetResponse.sort(function(a,b){
	          //   if( a.nameJapanese < b.nameJapanese ) return -1;
	          //   if( a.nameJapanese > b.nameJapanese ) return 1;
	          //   return 0;
	          // });
	
	
	          renderData(); // 取得したデータを表示
	        }
	      }
	    };
	
	    x.open('GET', targetUrl);
	    x.responseType = 'json';
	    x.send();
	  }; // ---------------------------------------------------------------------------
	  // @function renderData
	  // 取得したデータを出力する関数
	  // ---------------------------------------------------------------------------
	
	
	  var renderData = function renderData() {
	    targetResponse.forEach(function (value, index) {
	      // 配列の要素1つずつへの処理
	      var dataNameEnglish = value.nameEnglish; // 変数の定義_英語名
	
	      var dataNameJapanese = value.nameJapanese; // 変数の定義_日本語名
	
	      var dataIndex = value.index; // 変数の定義_あかさたな...
	
	      var dataTag = value.tag; // 変数の定義_出演カテゴリ
	
	      var dataTagHtml = "";
	
	      if (dataTag) {
	        dataTagHtml = '<figcaption>' + dataTag + '</figcaption>';
	      }
	
	      var item = document.createElement('li'); // 追加するli要素の生成
	
	      item.classList.add('art-Contents_Artist_Item'); // 追加するli要素にクラス名を追加
	
	      item.innerHTML = "\n        <a class=\"item-anchor\" href=\"../artist/".concat(dataNameEnglish, "/\">\n          <figure class=\"art-Contents_Artist_Image\">\n            <img src=\"../assets/images/artist/img_").concat(dataNameEnglish, ".jpg?d=20191017\" width=\"150\" height=\"150\" alt=\"").concat(dataNameJapanese, "\">\n            ").concat(dataTagHtml, "\n          </figure>\n          <p class=\"art-Contents_Artist_Name\">").concat(dataNameJapanese, "</p>\n        </a>\n      ");
	      artistList.forEach(function (blockValue, blockIndex) {
	        if (indexArray[blockIndex] == dataIndex) {
	          blockValue.appendChild(item); // 該当のindex(あかさたな...)のul要素直下であれば表示
	        }
	      });
	    }); // *************************************************************************
	
	    artistList.forEach(function (value, index) {
	      if (!value.hasChildNodes()) {
	        value.classList.add('isHidden'); // display: none;
	
	        value.previousElementSibling.classList.add('isHidden'); // display: none;
	
	        value.parentNode.classList.add('isHidden'); // display: none;
	
	        artistLink[index].classList.add('isDisabled'); // pointer-events: none; color: (クリックできないことがわかる色);
	      }
	    }); // *************************************************************************
	  };
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preLoad = exports.modalPopup = exports.scrollBar = exports.placeNav = exports.tabMenu = exports.spMenu = exports.navSticky = exports.anchorLink = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var anchorLink = function anchorLink(type) {
	  $(document).ready(function () {
	    var urlId = location.hash;
	    var width = $(window).width();
	    var headerHeight = 0;
	    var scrollSpeed = 800;
	
	    if (width < 1001) {
	      headerHeight = $(".st-Header_Static").outerHeight();
	    } else {
	      if (type == "sub") {
	        headerHeight = $("#st-Header_Fixed").outerHeight() + $("#sw-Submenu_Fixed").outerHeight();
	      } else {
	        headerHeight = $("#st-Header_Fixed").outerHeight();
	      }
	    }
	
	    if (urlId) {
	      $('body,html').stop().scrollTop(0);
	      setTimeout(function () {
	        var loadTarget = $(urlId == "#" || urlId == "" ? 'html' : urlId).offset().top;
	        toAnker(loadTarget, headerHeight, scrollSpeed);
	      }, 100);
	    }
	
	    $('a[href^="#"]').on("click", function () {
	      var linkHref = $(this).attr("href");
	      var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	      var linkPosition = linkTarget.offset().top;
	      toAnker(linkPosition, headerHeight, scrollSpeed);
	      return false;
	    });
	
	    var toAnker = function toAnker(linkPosition, linkAdjust, linkSpeed) {
	      $("html, body").animate({
	        scrollTop: linkPosition - linkAdjust
	      }, linkSpeed, "swing");
	    };
	  });
	}; // ------------------------------------------------------------------------
	// headerSticky
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var navSticky = function navSticky(type) {
	  $(window).on("load resize", function () {
	    var header = $("#st-Header_Fixed");
	    var submenu = $("#sw-Submenu_Fixed");
	    var addclass1 = 'header-sticky';
	    var addclass2 = 'submenu-sticky';
	    var scrollY = 200;
	    var submenuPos = $('#sw-Submenu_Static').offset();
	
	    if ($(window).scrollTop() > scrollY) {
	      header.addClass(addclass1);
	    } else {
	      header.removeClass(addclass1);
	    }
	
	    $(window).scroll(function () {
	      if ($(window).scrollTop() > scrollY) {
	        header.addClass(addclass1);
	      } else {
	        header.removeClass(addclass1);
	      }
	    });
	
	    if (type == "sub") {
	      if ($(window).scrollTop() > submenuPos.top) {
	        submenu.addClass(addclass2);
	      } else {
	        submenu.removeClass(addclass2);
	      }
	
	      $(window).scroll(function () {
	        if ($(window).scrollTop() > submenuPos.top) {
	          submenu.addClass(addclass2);
	        } else {
	          submenu.removeClass(addclass2);
	        }
	      });
	    }
	  });
	}; // ------------------------------------------------------------------------
	// spMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.navSticky = navSticky;
	
	var spMenu = function spMenu() {
	  var flag = 0;
	  $('a.st-Header_Hamburger').on('click', function () {
	    $(this).toggleClass("hamburger_close");
	
	    if (flag == 0) {
	      $(".st-Header_Slide").addClass("sp_menu_open");
	      flag = 1;
	    } else {
	      $(".st-Header_Slide").removeClass("sp_menu_open");
	      $(".st-Header_Slide").removeClass("sp_menu_place_open");
	      $(".st-Header_Slide").removeClass("sp_menu_place_open").delay(300).queue(function (next) {
	        $(this).removeClass("sp_menu_place_open_option");
	        next();
	      });
	      flag = 0;
	    }
	  });
	  $('.place_toggle').on('click', function () {
	    if (flag == 0) {
	      $(".st-Header_Slide").addClass("sp_menu_place_open_option");
	      $('a.st-Header_Hamburger').addClass("hamburger_close");
	      $(".st-Header_Slide").addClass("sp_menu_place_open");
	      flag = 1;
	    } else {
	      $('a.st-Header_Hamburger').removeClass("hamburger_close");
	      $(".st-Header_Slide").removeClass("sp_menu_open");
	      $(".st-Header_Slide").removeClass("sp_menu_place_open").delay(300).queue(function (next) {
	        $(this).removeClass("sp_menu_place_open_option");
	        next();
	      });
	      flag = 0;
	    }
	  });
	}; // ------------------------------------------------------------------------
	// tabMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.spMenu = spMenu;
	
	var tabMenu = function tabMenu() {
	  $('.pla-Contents_Timetable_Item > .pla-Contents_Timetable_Tab').on('click', function () {
	    var index = $('.pla-Contents_Timetable_Item > .pla-Contents_Timetable_Tab').index(this);
	    $('.pla-Contents_Timetable_Item > .pla-Contents_Timetable_Tab').removeClass('active');
	    $(this).addClass('active');
	    $('.pla-Contents_Timetable_Table').removeClass('current');
	    $('.pla-Contents_Timetable_Table').eq(index).addClass('current');
	  });
	}; // ------------------------------------------------------------------------
	// placeNav
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.tabMenu = tabMenu;
	
	var placeNav = function placeNav() {
	  var count = 0;
	  var delay = 500;
	  $('.place_toggle,.st-Header_Place').mouseenter(function () {
	    count++;
	    $(".st-Header_Place").fadeIn(300);
	  }).mouseleave(function () {
	    count--;
	    setTimeout(function () {
	      if (!count) {
	        $(".st-Header_Place").fadeOut(300);
	      }
	    }, delay);
	  });
	  $(window).scroll(function () {
	    $(".st-Header_Place").fadeOut(300);
	  });
	}; // ------------------------------------------------------------------------
	// scrollBar
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.placeNav = placeNav;
	
	var scrollBar = function scrollBar() {
	  $(window).on("load", function () {
	    $(".sw-Fukubiki_Notice_Inner").mCustomScrollbar();
	  });
	}; // ------------------------------------------------------------------------
	// modalPopup
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.scrollBar = scrollBar;
	
	var modalPopup = function modalPopup() {
	  $('.popup').magnificPopup({
	    type: 'image'
	  });
	}; // ------------------------------------------------------------------------
	// modalPopup
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.modalPopup = modalPopup;
	
	var preLoad = function preLoad() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	};
	
	exports.preLoad = preLoad;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// artist/app.bundle.js